// ─── Discussion avec l'usager (canal « clavardage ») ───
// Ouvert dès l'activation de la session : un message de l'usager arrive même
// panneau fermé (pastille sur le bouton). `auteur` = nom du technicien côté
// envoi, `client` côté poste, affiché « Usager ».

import { useEffect, useRef, useState } from 'react';
import { useChannel } from './useChannel.js';

export function Chat({ sessionId, myName, visible, onIncoming, bureau }) {
  const [messages, setMessages] = useState([]);
  const [texte, setTexte] = useState('');
  const fil = useRef(null);

  const canal = useChannel(sessionId, 'clavardage', (e) => {
    if (typeof e.data !== 'string') return;
    let m;
    try { m = JSON.parse(e.data); } catch { return; }
    if (m.t !== 'message') return;
    setMessages((l) => [...l, { auteur: m.auteur, texte: m.texte, heure: m.heure || Date.now() }]);
    onIncoming?.(m.auteur);
  }, undefined, { restartKey: bureau });

  useEffect(() => {
    fil.current?.scrollTo({ top: fil.current.scrollHeight });
  }, [messages, visible]);

  function envoyer(e) {
    e.preventDefault();
    const t = texte.trim();
    if (!t || canal.etat !== 'ouvert') return;
    const m = { auteur: myName, texte: t, heure: Date.now() };
    canal.envoyer({ t: 'message', ...m });
    setMessages((l) => [...l, m]);
    setTexte('');
  }

  const nom = (a) => (a === myName ? 'Vous' : a === 'client' ? 'Usager' : a);

  return (
    <div className={`${visible ? 'flex' : 'hidden'} flex-col flex-1 min-h-0`}>
      <div ref={fil} className="flex-1 overflow-auto p-3 flex flex-col gap-2">
        {messages.length === 0 && (
          <p className="text-xs text-muted-2">Écrivez à l’usager : le message s’affiche dans la fenêtre de discussion de son poste.</p>
        )}
        {messages.map((m, i) => (
          <div
            key={i}
            className={`max-w-[85%] rounded-lg px-3 py-2 text-xs ${
              m.auteur === myName ? 'self-end bg-blue-500/15 text-fg' : 'self-start bg-rule text-fg'
            }`}
          >
            <div className="text-[10px] text-muted-2 mb-0.5">
              {nom(m.auteur)}, {new Date(m.heure).toLocaleTimeString('fr-CA', { hour: '2-digit', minute: '2-digit' })}
            </div>
            <div className="whitespace-pre-wrap break-words">{m.texte}</div>
          </div>
        ))}
      </div>
      {canal.etat === 'ferme' && <div className="px-3 py-1.5 text-xs text-red-300">{canal.raison}</div>}
      <form onSubmit={envoyer} className="p-2 border-t border-rule flex gap-2">
        <input
          className="flex-1 bg-app border border-rule-3 rounded-lg px-3 py-1.5 text-xs text-fg"
          value={texte}
          onChange={(e) => setTexte(e.target.value)}
          placeholder="Votre message…"
          aria-label="Message à l’usager"
          disabled={canal.etat !== 'ouvert'}
        />
        <button
          className="bg-blue-500 border-none rounded-lg px-3 py-1.5 text-white text-xs font-semibold cursor-pointer disabled:opacity-50"
          disabled={!texte.trim() || canal.etat !== 'ouvert'}
        >
          Envoyer
        </button>
      </form>
    </div>
  );
}
